const storybookBaseArg = {
  colorScheme: {
    options: [
      'white',
      'dark', 
      'lightOrange',
      'whiteyMint',
      'tecnica',
      'umanistica',
      'economica',
      'medicina'
    ],
    control: {
      type: 'select' as const,
    },
    table: {
      disable: true
    }
  },
  type: {
    table: {
      disable: true
    }
  },
  sectionId: {
    table: {
      disable: true
    }
  }
}

export default storybookBaseArg